import React from 'react'
import { getFileName } from '../../../helpers/FileCaching';

import classes from './ExternalArticles.module.scss';


function ExternalArticles(props){
	
	const externalArticles = props.content.article_links.map(item => {
		let articles =
		<article key={item.id} className={` ${classes['external_articles__article']} col-6 col-lg-3`}>
				<a href={item.url} target='blank' className={`radial-link ${classes['external_articles__article--link']}`}>
					<header className={classes['external_articles__article--title']}>{item.title}</header>
					<div className={`${classes['external_articles__article--container-image']}`}>
						<img src={getFileName(props.globalImages, item.image)} className={`${classes['external_articles__article--image']}`} alt={item.title} />
					</div>
				</a>
		</article>

		return articles
	});


	return (
		<section id={"external_articles"} className={classes.external_articles}>
			<div className={classes['external_articles__wrapper']}>

				<div className={`text_subtitle_wrapper ${classes.external_articles__subtitle_wrapper}`}>
					<p className={`${classes.external_articles__header}`}>{props.content.title}</p>
				</div>
				<div className={classes['external_articles__article-wrapper']}>
					{externalArticles}
					
				</div>
			</div>
			
		</section>
	)
}

export default ExternalArticles